import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
// import fetch from 'isomorphic-fetch';

//import img

//import components
import StrucutreListItemSingle from './StrucutreListItemSingle.js';
import StrucutreListItemContent from './StrucutreListItemContent.js';

const apiAddress = process.env.REACT_APP_API;

const StrucutreListItem = ({
    label, 
    id, 
    children, 
    getFieldChildren, 
    expansible, 
    setStructureListHeight, 
    shortDescription, 
    recordsNumber,
    setOpened
}) => {
    const [isOpened, setIsOpened] = useState(false);
    const [ listOfExpansibleToLoad, setListOfExpansibleToLoad ] = useState(null);

    const [ additionalIdsFromExpansibles, setAdditionalIdsFromExpansibles ] = useState([]);

    const childrenIds = useMemo(() => {
        if (!children || children.length === 0) return [];
    
        const listToLoad = [];
        const baseChildrenIds = children.map(child => {
            if (child.expansible) {
                listToLoad.push(child.id);
            }
            return child.id;
        });
        setListOfExpansibleToLoad(listToLoad);
        return baseChildrenIds;
    }, [children]);

    const getDeepList = async (ids) => {
        // console.log("IDS TO LOAD: ", ids);
        // const requests = [];

        // for (const id of ids) {
        //     requests.push(fetch(`${apiAddress}/heading/get/${id}`));
        // }

        // const responses = await Promise.all(requests);

        // const data = await Promise.all(responses.map(response => response.json()));
        // console.log("DATA: ", data);
        // setAdditionalIdsFromExpansibles(data.map(item => item.id));
    };

    // useEffect(() => {
    //     if (listOfExpansibleToLoad) {
    //         getDeepList(listOfExpansibleToLoad);
    //     }
    // }, [listOfExpansibleToLoad]);

    useEffect(() => {
        if (setOpened) {
            setIsOpened(true);
        }
    }, [setOpened]);

    const toggleOpened = () => {
        if (!isOpened && !children && expansible) {
            getFieldChildren(id);
        }
        setIsOpened(!isOpened);
        setStructureListHeight();
    };

    return (
        <li className="structure__list-item">
            <div 
                className="structure__list-item__container" 
            >
                <button 
                    className={isOpened ? "structure__hide" : "structure__open"}
                    onClick={toggleOpened}
                >
                    { isOpened ? ( <span>-</span> ) : ( <span>+</span> ) }
                </button>
                <StrucutreListItemContent 
                    id={id} 
                    childrenIds={childrenIds}
                    label={label} 
                    shortDescription={shortDescription} 
                    recordsNumber={recordsNumber}
                    setStructureListHeight={setStructureListHeight}
                />
            </div>
            {(isOpened && children) &&(
                <ul className="structure__inner-list">
                    {children.map((child, index) => 
                        (child.expansible || (child.children && child.children.length > 0)) 
                        ? (
                            <StrucutreListItem 
                                key={index} 
                                getFieldChildren={getFieldChildren}
                                setStructureListHeight={setStructureListHeight}
                                {...child}
                            />
                        ) : (
                            <StrucutreListItemSingle
                                key={index} 
                                setStructureListHeight={setStructureListHeight}
                                {...child}
                            />
                        )
                    )}
                </ul>
            )}
        </li>
    );
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default withRouter(connect(mapStateToProps)(StrucutreListItem));


// WEBPACK FOOTER //
// ./src/components/characteristics/StrucutreListItem.js